module.exports = __webpack_public_path__ + "img/about-5.3916120a.jpg";